import { clsx } from 'clsx';
import type { TOCListItem as TOCListItemType } from '../../interfaces/toc';
import styles from './TocListItem.module.scss';

interface TocListItemProps {
  item: TOCListItemType;
  isActiveItem: boolean;
  onClickItem: () => void;
}

export function TocListItem({ isActiveItem, item, onClickItem }: TocListItemProps) {
  return (
    <span
      role='button'
      tabIndex={0}
      aria-describedby='toc item'
      key={item.domId}
      className={clsx(
        'center-flex-row',
        isActiveItem && 'text-primary text-bold',
        !isActiveItem && 'text-secondary',
        styles.tocListItem
      )}
      onKeyDown={() => {}}
      onClick={onClickItem}
    >
      {item.title}
    </span>
  );
}
